import { render, staticRenderFns } from "./InputLogradouro.vue?vue&type=template&id=97096a80"
import script from "./InputLogradouro.vue?vue&type=script&lang=js"
export * from "./InputLogradouro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports